import { render, staticRenderFns } from "./addEditViewDialog.vue?vue&type=template&id=3bc1733e&scoped=true"
import script from "./addEditViewDialog.vue?vue&type=script&lang=js"
export * from "./addEditViewDialog.vue?vue&type=script&lang=js"
import style0 from "./addEditViewDialog.vue?vue&type=style&index=0&id=3bc1733e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1733e",
  null
  
)

export default component.exports